// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_o3-0";
export var animationContainer = "_o3-1";
export var itemPrice = "_o3-a";
export var itemizedContent = "_o3-9";
export var itemizedHeader = "_o3-7";
export var itemizedRow = "_o3-8";
export var itemizedSection = "_o3-6";
export var modalContent = "_o3-2";
export var orderName = "_o3-3";
export var refundOption = "_o3-4";
export var refundOptionsContainer = "_o3-5";
export var shippingLabel = "_o3-b";
export var totalRow = "_o3-c";